import React, { useState, useEffect } from "react";

const AnimateNumbers = ({ targetNumber, duration = 3000 }) => {
  const [currentNumber, setCurrentNumber] = useState(0);

  useEffect(() => {
    let startTime = null;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1); // Clamp between 0 and 1
      const animatedValue = Math.round(percentage * targetNumber);

      setCurrentNumber(animatedValue);

      if (progress < duration) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);

    // Clean up in case the component unmounts during animation
    return () => cancelAnimationFrame(animate);
  }, [targetNumber, duration]);

  return (
    <div>{currentNumber}</div>
  );
};

export default AnimateNumbers;